import { Navigate } from 'react-router-dom';
import { useAuth } from 'shared/hooks/useAuth';
import { ROUTES } from 'shared/constants/routes';
import { MarketingHomePage } from 'modules/jogador/home/MarketingHomePage';
import { PlayerHomePage } from 'modules/jogador/player-home/PlayerHomePage';

export function HomePage() {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user?.role === 'jogador') return <PlayerHomePage />;
  if (isAuthenticated && user?.role === 'arena') return <Navigate to={ROUTES.ARENA_DASHBOARD} replace />;
  if (isAuthenticated && user?.role === 'admin') return <Navigate to={ROUTES.ADMIN_DASHBOARD} replace />;
  if (isAuthenticated && user?.role === 'instrutor') return <Navigate to={ROUTES.INSTRUCTOR_CLASSES} replace />;
  if (isAuthenticated && user?.role === 'recepcao') return <Navigate to={ROUTES.RECEPCAO_RESERVATIONS} replace />;

  return <MarketingHomePage />;
}
